import { videoSpecOptions } from 'client/constants/videoSpecOptions';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getAllCategoryTours } from 'client/_redux/actions/categoryTour';
import { RootState } from 'client/_redux/reducers';
import { ISelectorOption } from 'types/ISelectorOption';

export const useVideoDetails = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const { videoTypeOptions } = videoSpecOptions(t);

  const allCategoryTours = useSelector(
    (state: RootState) => state.categoryTour.allCategoryTours,
  );

  useEffect(() => {
    dispatch(getAllCategoryTours());
  }, [dispatch]);

  const parcourTypeOptions: ISelectorOption<string>[] = (
    allCategoryTours?.categoryTours || []
  ).map((cat) => ({
    label: cat.name,
    value: cat._id,
  }));

  return { t, parcourTypeOptions, videoTypeOptions };
};
